import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

const PaymentCancelled = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="h-10 w-10 text-red-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Zahlung abgebrochen</h1>
        
        <p className="text-gray-600 mb-8">
          Deine Zahlung wurde abgebrochen. Keine Sorge, es wurde nichts von deinem Konto abgebucht.
        </p>
        
        <div className="space-y-4">
          <Link 
            to="/premium"
            className="block w-full bg-orange-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-orange-600 transition flex items-center justify-center space-x-2"
          >
            <CreditCard className="h-5 w-5" />
            <span>Zurück zu Premium-Optionen</span>
          </Link>
          
          <Link 
            to="/"
            className="block w-full bg-gray-100 text-gray-700 px-6 py-3 rounded-lg font-medium hover:bg-gray-200 transition flex items-center justify-center space-x-2"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Zurück zur Startseite</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;